import React, { createContext, useState, useEffect } from 'react';

interface ThemeContextType {
  isDark: boolean;
  setIsDark: (isDark: boolean) => void;
}

// Create the context with a default value (default theme is dark)
export const ThemeContext = createContext<ThemeContextType>({
  isDark: true,
  setIsDark: () => {},
});

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDark, setIsDarkState] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    // Default to dark when no preference is saved
    return savedTheme !== 'light';
  });

  useEffect(() => {
    if (isDark) {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
      localStorage.setItem('theme', 'light');
    }
  }, [isDark]);

  return (
    <ThemeContext.Provider value={{ isDark, setIsDark: setIsDarkState }}>
      {children}
    </ThemeContext.Provider>
  );
};
